export enum SituacaoEstabelecimentoEnum {
    AGUARDANDO_CERTIFICACAO = "Aguardando Certificação",
    CERTIFICADO = "Certificado",
    CANCELADO = "Cancelado",
    OUTROS = "Outros"
}